$('#filter-menu-menu-profile').on('change', function ($data) {
    var target = window.location.origin + window.location.pathname + '?_locale=' + this.value;
    window.location.replace(target);
});


function showDeleteModal() {
    $('.areYouSure').css('display', 'block');
}

function showModal() {
    $('.challenge-over').css('display', 'block');
}

function deleteUser(path) {
    $.ajax({
        url: window.origin + path,
        success: function (response) {
            var newDoc = document.open("text/html", "replace");
            newDoc.write(response);
            newDoc.close();
        },
        error: function (e) {
            console.log('Delete error');
        }
    });
}
